require('./pages.index');
require('./pages.news');
require('./pages.signin');